import { Link } from 'react-router-dom';

function IconCode() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="m8 8-4 4 4 4M16 8l4 4-4 4M13 6l-2 12" />
    </svg>
  );
}

function IconRocket() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 19c-4 0-7-3-7-7 4-1 7-4 8-8 4 1 7 4 8 8-1 4-4 7-9 7z" />
      <path d="M9 15c-1.5 1-3 1.2-4.5.8 1.2-2 .2-3.5-.8-4.5C6 12 7.5 13.5 9 15z" />
      <circle cx="13.5" cy="10.5" r="1" />
    </svg>
  );
}

function IconDatabase() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="12" cy="6" rx="7" ry="3" />
      <path d="M5 6v6c0 1.7 3.1 3 7 3s7-1.3 7-3V6" />
      <path d="M5 12v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" />
    </svg>
  );
}

function IconShield() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3 5 6v6c0 4.2 2.8 7.4 7 9 4.2-1.6 7-4.8 7-9V6l-7-3z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

function IconCloud() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.5 19a4.5 4.5 0 0 0 .42-8.98 6 6 0 0 0-11.7 1.62A3.75 3.75 0 0 0 6.75 19h10.75z" />
    </svg>
  );
}

function IconPhone() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="7" y="2.5" width="10" height="19" rx="2" />
      <path d="M11 18.5h2" />
    </svg>
  );
}

function IconLayers() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="m12 3 8 4.5-8 4.5L4 7.5 12 3z" />
      <path d="m4 12 8 4.5 8-4.5" />
      <path d="m4 16.5 8 4.5 8-4.5" />
    </svg>
  );
}

function HomePage() {
  return (
    <div className="landing lp">
      <section className="lp-hero">
        <div className="lp-hero-inner">
          <div>
            <h1 className="lp-title">
              Build, deploy, and scale
              <span className="lp-title-accent"> practical software.</span>
            </h1>
            <p className="lp-subtitle">
              Gorty's Tech, LLC helps businesses build, deploy, scale, and
              maintain practical software — web and mobile applications,
              cost-effective deployments of existing code, and Azure capacity
              matched to real traffic.
            </p>
            <div className="lp-actions">
              <Link to="/request-services" className="lp-btn lp-btn--primary">
                Request Services
              </Link>
              <a href="#services" className="lp-btn lp-btn--ghost">
                See services
              </a>
            </div>
            <ul className="lp-trust">
              <li>.NET, single-page apps, and mobile</li>
              <li>IdentityServer and OAuth 2.0</li>
              <li>Apple App Store and Google Play</li>
              <li>Azure CI/CD, scaling, and databases</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="lp-section" id="services">
        <header className="lp-section-head">
          <h2>Services built around how businesses actually ship software</h2>
          <p>
            Practical technology work: custom web and mobile applications,
            taking existing or AI-assisted software into production, and
            keeping the data layer healthy.
          </p>
        </header>
        <div className="lp-grid lp-grid--split">
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-blue"><IconCode /></div>
            <h3>Full Stack Web Application Development</h3>
            <p>
              Custom business applications on the .NET stack, with user-facing
              pages in Vite, Vue, React, Angular, and similar SPA tooling.
            </p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-purple"><IconPhone /></div>
            <h3>Mobile App Development</h3>
            <p>
              Mobile applications built for both stores, including submission
              and release on the Apple App Store and Google Play.
            </p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-green"><IconRocket /></div>
            <h3>AI-Assisted Setup, Deployment, and Scaling</h3>
            <p>
              Help businesses take AI-generated, vibe-coded, or prototype
              software and turn it into reliable, maintainable, deployed
              applications.
            </p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-amber"><IconDatabase /></div>
            <h3>Database Administration &amp; Management</h3>
            <p>
              Support database setup, maintenance, optimization, backups,
              migrations, troubleshooting, and data-driven application needs.
            </p>
          </article>
        </div>
      </section>

      <section className="lp-section lp-section--alt" id="focus">
        <header className="lp-section-head">
          <h2>Where the work is focused</h2>
          <p>
            Web or mobile, on a current stack or an existing one — then
            deployed, released, and scaled for the traffic it actually gets.
          </p>
        </header>
        <div className="lp-grid">
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-blue"><IconCode /></div>
            <h3>.NET stack</h3>
            <p>
              Business applications, APIs, and services built on the modern
              .NET stack, with the data and deployment work included.
            </p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-purple"><IconShield /></div>
            <h3>User-facing pages with current authentication</h3>
            <p>
              Pages and applications people actually use, secured with an
              up-to-date authentication stack: IdentityServer and OAuth 2.0.
            </p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-cyan"><IconRocket /></div>
            <h3>Single-page applications</h3>
            <p>
              SPAs built with current tooling, including Vite, Vue, React,
              Angular, and similar frontend stacks.
            </p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-purple"><IconPhone /></div>
            <h3>Mobile apps on both stores</h3>
            <p>
              From the app itself through store listing and release on the
              Apple App Store and Google Play.
            </p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-amber"><IconLayers /></div>
            <h3>Any stack, deployed economically</h3>
            <p>
              An existing application — whatever framework or language it was
              written in — hosted in the most cost-effective way that still
              fits how it runs.
            </p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-green"><IconCloud /></div>
            <h3>Azure CI/CD and scaling</h3>
            <p>
              Pipelines that build and release changes, and Azure resources
              scaled to the size of the user traffic.
            </p>
          </article>
        </div>
      </section>

      <section className="lp-section">
        <header className="lp-section-head">
          <h2>Why work with Gorty's Tech</h2>
          <p>
            A practical, results-oriented approach — from the first prototype
            through a system people can actually run.
          </p>
        </header>
        <div className="lp-grid">
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-cyan"><IconCode /></div>
            <h3>Practical business-focused solutions</h3>
            <p>Software aimed at a real operating need, not a demo that stalls after the first week.</p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-blue"><IconCode /></div>
            <h3>Full-stack development experience</h3>
            <p>.NET services, single-page frontends, mobile apps, data, and Azure deployment handled as one system.</p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-amber"><IconDatabase /></div>
            <h3>Database-first thinking</h3>
            <p>Data models, backups, and query performance treated as part of the product.</p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-green"><IconRocket /></div>
            <h3>Deployment and scaling support</h3>
            <p>CI/CD for reliable releases, and Azure resources adjusted as user traffic grows.</p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-purple"><IconRocket /></div>
            <h3>Prototypes into production tools</h3>
            <p>Rough AI-assisted or vibe-coded drafts reshaped into maintainable software.</p>
          </article>
          <article className="lp-card">
            <div className="lp-card-icon lp-tint-red"><IconCode /></div>
            <h3>Clear communication</h3>
            <p>Straightforward updates and code another developer can pick up later.</p>
          </article>
        </div>
      </section>

      <section className="lp-section lp-section--alt">
        <div className="lp-pricing">
          <div className="lp-pricing-copy">
            <h2>Ready to talk through a project?</h2>
            <p>
              Tell us what you need. No commitment required — just a conversation
              about the software, the deployment, or the database work in front of you.
            </p>
          </div>
          <div className="lp-pricing-cta">
            <Link to="/request-services" className="lp-btn lp-btn--primary lp-btn--lg">
              Request Services
            </Link>
            <span className="lp-pricing-note">Web apps, mobile apps, deployments, and databases</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
